import * as types from '../mutations'
import _ from 'lodash'
import Format from 'services/Format'

const services = {
  campaign: window.abp.services.app.campaign
}

// initial state
const state = {
  all: [],
  pagination: {},
  activeCampaign: {},
  links: [],
  campaignReport: {},
  opens: [],
  clicks: []
}

// getters
const getters = {
  allCampaigns: state => state.all,
  allCampaignsPagination: state => state.pagination,
  activeCampaign: state => state.activeCampaign,
  allLinks: state => state.links,
  campaignReport: state => state.campaignReport,
  allClicks: state => state.clicks,
  allOpens: state => state.opens
}

// actions
const actions = {
  getAllCampaigns({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.campaign.getList(request).done(function (response) {
        let campaigns = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_CAMPAIGNS, { campaigns, pagination })
        resolve()
      })
    })
  },
  getCampaign({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.campaign.get(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, response)
        resolve()
      })
    })
  },
  createOrUpdateCampaign({ commit }, campaign) {
    return new Promise((resolve, reject) => {
      let action = _.isEmpty(campaign.id) ? services.campaign.create(campaign) : services.campaign.update(campaign)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  updateBody({ commit }, campaign) {
    return new Promise((resolve, reject) => {
      services.campaign.updateBody(campaign)
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  duplicateCampaign({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.campaign.duplicate({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, null)
          resolve()
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  deleteCampaign({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.campaign.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, null)
          resolve()
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  sendCampaign({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.send(request)
        .done(function (response) {
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  sendTest({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.sendTest(request)
        .done(function (response) {
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  scheduleCampaign({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.schedule(request)
        .done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  unscheduleCampaign({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.unschedule(request)
        .done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_CAMPAIGN, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  getLinks({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.campaign.getLinks({ id })
        .done(function (response) {
          commit(types.DATA.RECEIVE_LINKS, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  getReport({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.campaign.getReport({ id })
        .done(function (response) {
          commit(types.DATA.RECEIVE_CAMPAIGN_REPORT, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  getClicks({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.getClicks(request)
        .done(function (response) {
          commit(types.DATA.RECEIVE_CAMPAIGN_CLICKS, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  },
  getOpens({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.campaign.getOpens(request)
        .done(function (response) {
          commit(types.DATA.RECEIVE_CAMPAIGN_OPENS, response)
          resolve(response)
        })
        .fail(function (response) {
          reject(response)
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_CAMPAIGNS](state, { campaigns, pagination }) {
    state.all = campaigns
    state.pagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_CAMPAIGN](state, campaign) {
    state.activeCampaign = campaign
  },
  [types.DATA.RECEIVE_LINKS](state, links) {
    let orderedLinks = _.orderBy(links.links, 'clicksCount', 'desc')
    for (var i = 0, len = orderedLinks.length; i < len; i++) {
      let text = orderedLinks[i].text
      orderedLinks[i].text = Format.stripAdnTrimString(text)
    }
    state.links = orderedLinks
  },
  [types.DATA.RECEIVE_CAMPAIGN_REPORT](state, campaignReport) {
    state.campaignReport = campaignReport
  },
  [types.DATA.RECEIVE_CAMPAIGN_CLICKS](state, clicks) {
    state.clicks = clicks.items
  },
  [types.DATA.RECEIVE_CAMPAIGN_OPENS](state, opens) {
    state.opens = opens.items
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/campaigns.js